import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-about',
  imports: [CommonModule, RouterLink],
  templateUrl: './about.html',
  styleUrl: './about.css'
})
export class About {
  values = [
    { icon: 'lightbulb', title: 'Innovation', description: 'We embrace cutting-edge technologies and creative solutions.' },
    { icon: 'shield', title: 'Integrity', description: 'We maintain the highest standards of honesty and transparency.' },
    { icon: 'users', title: 'Collaboration', description: 'We work closely with clients to achieve shared success.' },
    { icon: 'star', title: 'Excellence', description: 'We strive for perfection in everything we do.' }
  ];

  team = [
    { name: 'Alex Thompson', role: 'CEO & Founder', avatar: 'AT' },
    { name: 'Sarah Chen', role: 'CTO', avatar: 'SC' },
    { name: 'Michael Roberts', role: 'Head of Design', avatar: 'MR' },
    { name: 'Emily Davis', role: 'Lead Developer', avatar: 'ED' }
  ];
}
